module.exports = __webpack_public_path__ + "img/signup-ellipse-filled.a51c08aa.png";